/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Hero_H1_BeforeInputs */

const es_l7_hero_h1_before = /** @type {(inputs: L7_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pon tu barco a navegar. Y a `)
};

const gl_l7_hero_h1_before = /** @type {(inputs: L7_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pon o teu barco a navegar. E a `)
};

const en_l7_hero_h1_before = /** @type {(inputs: L7_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get your boat sailing. And `)
};

/**
* | output |
* | --- |
* | "Get your boat sailing. And" |
*
* @param {L7_Hero_H1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_hero_h1_before = /** @type {((inputs?: L7_Hero_H1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Hero_H1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_hero_h1_before(inputs)
	if (locale === "en") return en_l7_hero_h1_before(inputs)
	return es_l7_hero_h1_before(inputs)
});